import type { FC } from 'react';
import { useFormContext } from 'react-hook-form';

import { transformDateString, Tag, Range } from '@catalyze/ui';

type IDateRangeMenuRangeProps = {
    inputName: string;
};

export const DateRangeMenuTags: FC<IDateRangeMenuRangeProps> = ({
    inputName,
}) => {
    const { resetField, watch } = useFormContext();
    const { [Range.MAX]: max, [Range.MIN]: min } = watch(inputName);

    if (!min && !max) return null;
    const minDate = min ? new Date(min) : undefined;
    const maxDate = max ? new Date(max) : undefined;
    let text = '';
    if (minDate && maxDate) {
        if (min === max) {
            text = transformDateString(minDate);
        } else {
            text = `${transformDateString(minDate)} - ${transformDateString(
                maxDate
            )}`;
        }
    } else if (!minDate && maxDate) {
        text = `Before ${transformDateString(maxDate)}`;
    } else if (!maxDate && minDate) {
        text = `After ${transformDateString(minDate)}`;
    }
    // eslint-disable-next-line max-statements-per-line
    return (
        <Tag
            value={text}
            onDelete={() => {
                resetField(`${inputName}`);
                resetField(`${inputName}.max`);
                resetField(`${inputName}.min`);
            }}
        />
    );
};

DateRangeMenuTags.defaultProps = {};
